import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { leagueForm } from '../../../../service/leagueTable';
import { leagueSetTeamInfo } from '../../../../redux/actions/League';
import { showPopupWindow } from '../../../../redux/actions/Popups';
import { showMobileSidebarSection } from '../../../../redux/actions/Team';
import { POPUPS } from '../../../../service/constants';
import {
  StyledFormCard,
  StyledFormHead,
  StyledFormRow,
  StyledFormTeam,
  StyledFormPills,
  StyledFormPill,
  StyledFormCs,
  StyledFormEmpty,
} from './styled';

const SLOTS = 5;

const LeagueForm = ({ teams, fixtures, myTeamId, isLoading }) => {
  const dispatch = useDispatch();
  const formByTeam = useMemo(() => leagueForm(fixtures, SLOTS), [fixtures]);
  const crestByTeamId = useMemo(() => {
    const map = {};
    (fixtures || []).forEach((day) => {
      (day?.matches || []).forEach((match) => {
        if (match?.home_team?._id && match.home_team.symbol) {
          map[String(match.home_team._id)] = match.home_team.symbol;
        }
        if (match?.away_team?._id && match.away_team.symbol) {
          map[String(match.away_team._id)] = match.away_team.symbol;
        }
      });
    });
    return map;
  }, [fixtures]);
  const rows = useMemo(
    () =>
      (teams || []).map((team) => {
        const id = team?._id != null ? String(team._id) : '';
        const entry = formByTeam[id] || { results: [], cleanSheets: 0 };
        return {
          id,
          name: team?.name || '',
          symbol: team?.symbol || crestByTeamId[id] || '',
          results: entry.results,
          cleanSheets: entry.cleanSheets,
          own: Boolean(myTeamId && id === String(myTeamId)),
        };
      }),
    [teams, formByTeam, crestByTeamId, myTeamId]
  );
  const played = rows.some((row) => row.results.length > 0);

  const openTeam = (id) => {
    if (!id) return;
    dispatch(leagueSetTeamInfo({ _id: id }, isMobileOnly));
    if (isMobileOnly) {
      dispatch(showMobileSidebarSection('teamInfo'));
    } else {
      dispatch(showPopupWindow(POPUPS.TEAM_INFO_POPUP, POPUPS.TEAM_INFO_POPUP, true));
    }
  };

  return (
    <StyledFormCard>
      {isLoading && !played ? (
        <StyledFormEmpty>Loading…</StyledFormEmpty>
      ) : !played ? (
        <StyledFormEmpty>No matches played yet</StyledFormEmpty>
      ) : (
        <>
          <StyledFormHead>
            <span>Team</span>
            <span>Last {SLOTS}</span>
            <span>CS</span>
          </StyledFormHead>
          {rows.map((row) => {
            const pills = Array.from({ length: SLOTS }, (_, index) => {
              const offset = SLOTS - row.results.length;
              return index < offset ? '' : row.results[index - offset];
            });
            return (
              <StyledFormRow
                key={row.id || row.name}
                type="button"
                $own={row.own}
                onClick={() => openTeam(row.id)}
              >
                <StyledFormTeam $own={row.own}>
                  {row.symbol ? <img src={row.symbol} alt="" /> : null}
                  <strong>{row.name}</strong>
                </StyledFormTeam>
                <StyledFormPills>
                  {pills.map((result, index) => (
                    <StyledFormPill key={`${row.id}-${index}`} $result={result}>
                      {result || ''}
                    </StyledFormPill>
                  ))}
                </StyledFormPills>
                <StyledFormCs>{row.cleanSheets}</StyledFormCs>
              </StyledFormRow>
            );
          })}
        </>
      )}
    </StyledFormCard>
  );
};

LeagueForm.propTypes = {
  teams: PropTypes.array,
  fixtures: PropTypes.array,
  myTeamId: PropTypes.string,
  isLoading: PropTypes.bool,
};

LeagueForm.defaultProps = {
  teams: [],
  fixtures: [],
  myTeamId: null,
  isLoading: false,
};

export default LeagueForm;
